import { ApiRequestError } from "../../api/util";

/**
 * Serverens maskinlæsbare årsag på en 409 fra `POST IdKort`. Skal matche konstanterne i
 * `IdKortController` i aika-indberetning-backend.
 */
export const IDKORT_CODE_ANMODNING_I_GANG = "IDKORT_ANMODNING_I_GANG";
export const IDKORT_CODE_PERSON_FINDES_IKKE = "PERSON_FINDES_IKKE";

/**
 * Hvad en fejlet indsendelse betyder for statuszonen.
 *
 * `existingOrder` — der ligger allerede en anmodning. Ikke medlemmets fejl, så zonen falder ud i
 * den gule "under behandling" og formularen låses.
 * `error` — indsendelsen blev ikke gemt. Skal vises som en rød fejl med serverens besked.
 */
export type IdKortSubmitFailure = "existingOrder" | "error";

const getErrorCode = (error: ApiRequestError): string | null => {
  const { data } = error;
  if (!data || typeof data !== "object" || !("code" in data)) return null;
  const code = (data as { code: unknown }).code;
  return typeof code === "string" ? code : null;
};

/**
 * Afgør, hvad en fejlet indsendelse skal vise.
 *
 * Serveren bruger 409 til to forskellige ting, og forskellen er ikke kosmetisk: den ene betyder,
 * at bestillingen allerede ligger og venter, den anden (ADV-274) at intet blev gemt, fordi
 * medlemmets Person-række endnu ikke er synkroniseret fra AIKA (ADV-272). Læses de ens, får et
 * medlem, hvis bestilling IKKE blev gemt, at vide at den er under behandling — værre end den
 * generiske fejl, der stod der før, for så går medlemmet fra siden i tro om, at kortet er bestilt.
 *
 * En 409 UDEN code læses bevidst som `existingOrder`. Det er den gamle backend, hvor 409 kun kunne
 * betyde dobbeltbestilling, og portalen deployes uafhængigt af backenden: defaulten gør, at denne
 * ændring kan gå i luften først uden at ændre noget som helst.
 */
export const getIdKortSubmitFailure = (error: unknown): IdKortSubmitFailure => {
  if (!(error instanceof ApiRequestError) || error.status !== 409)
    return "error";

  return getErrorCode(error) === IDKORT_CODE_PERSON_FINDES_IKKE
    ? "error"
    : "existingOrder";
};
